export default __webpack_public_path__ + "static/banner-how-to-improve-your-credit-score-8f00f6296de7480a8c1fb4d7da8aecf3.jpg";